import Vue from 'vue';
import Router from 'vue-router';
import RefreshLimit from '@/js/time'

Vue.use(Router);

const __import__ = (file) => () =>
    import(`@/pages/${file}.vue`);
    
const WebT = '医影智能';

const router = new Router({
    mode: 'history',
    routes:[
        {
            path: '/',
            name: 'home',
            component: __import__('home'),
            meta: {
                title: WebT
            }
        },
        {
            path: '/about',
            name: 'about',
            component: __import__('about'),
            meta: {
                title: WebT+'-关于我们'
            }
        },
        {
            path: '/product',
            name: 'product',
            component: __import__('product'),
            meta: {
                title: WebT+'-医影产品-软件产品'
            }
        },
        {
            path: '/hardware',
            name: 'hardware',
            component: __import__('hardware'),
            meta: {
                title: WebT+'-医影产品-硬件产品'
            }
        },
        {
            path: '/news',
            name: 'news',
            component: __import__('news'),
            meta: {
                title: WebT+'-新闻资讯'
            }
        },
        // {
        //     // 弃用
        //     path: '/newsDetail',
        //     name: 'newsDetail',
        //     component: __import__('newsDetail'),
        //     meta: {
        //         title: WebT+'-新闻资讯'
        //     }
        // },
        {
            path: '/co',
            name: 'co',
            component: __import__('co'),
            meta: {
                title: WebT+'-合作院校'
            }
        },
        {
            path: '/people',
            name: 'people',
            component: __import__('people'),
            meta: {
                title: WebT+'-人才招聘'
            }
        },
        {
            path: '/contact',
            name: 'contact',
            component: __import__('contact'),
            meta: {
                title: WebT+'-联系我们'
            }
        },
        {
            path: '/medical',
            name: 'medical',
            component: __import__('medical'),
            meta: {
                title: WebT+'-医影产品'
            }
        },
        {
            path: '/search',
            name: 'search',
            component: () => import('@/components/search/search.vue'),
            meta: {
                title: WebT+'-搜索'
            }
        },


        // 详情页

        //医学影像中心VR系统
        {
            path: '/vr',
            name: 'vr',
            component: () => import('@/components/products/vr.vue'),
            meta: {
                title: WebT+'-VR系统'
            }
        },

        //设备结构虚拟仿真系统
        {
            path: '/deviceCT',
            name: 'deviceCT',
            component: () => import('@/components/products/deviceCT.vue'),
            meta: {
                title: WebT+'-CT设备结构虚拟仿真系统'
            }
        },
        {
            path: '/deviceDR',
            name: 'deviceDR',
            component: () => import('@/components/products/deviceDR.vue'),
            meta: {
                title: WebT+'-DR设备结构虚拟仿真系统'
            }
        },
        {
            path: '/deviceMRI',
            name: 'deviceMRI',
            component: () => import('@/components/products/deviceMRI.vue'),
            meta: {
                title: WebT+'-MRI设备结构虚拟仿真系统'
            }
        },

        //性能检测虚拟仿真系统
        {
            path: '/perCT',
            name: 'perCT',
            component: () => import('@/components/products/perCT.vue'),
            meta: {
                title: WebT+'-CT性能检测虚拟仿真系统'
            }
        },
        {
            path: '/perDR',
            name: 'perDR',
            component: () => import('@/components/products/perDR.vue'),
            meta: {
                title: WebT+'-DR性能检测虚拟仿真系统'
            }
        },
        {
            path: '/perMRI',
            name: 'perMRI',
            component: () => import('@/components/products/perMRI.vue'),
            meta: {
                title: WebT+'-MRI性能检测虚拟仿真系统'
            }
        },

        //检查技术虚拟仿真系统
        {
            path: '/checkCT',
            name: 'checkCT',
            component: () => import('@/components/products/checkCT.vue'),
            meta: {
                title: WebT+'-CT检查技术虚拟仿真系统'
            }
        },
        {
            path: '/checkDR',
            name: 'checkDR',
            component: () => import('@/components/products/checkDR.vue'),
            meta: {
                title: WebT+'-DR检查技术虚拟仿真系统'
            }
        },
        {
            path: '/checkMRI',
            name: 'checkMRI',
            component: () => import('@/components/products/checkMRI.vue'),
            meta: {
                title: WebT+'-MRI检查技术虚拟仿真系统'
            }
        },

        //CT、DR、MRI-硬件
        {
            path: '/CT',
            name: 'CT',
            component: () => import('@/components/products/hardware/CT.vue'),
            meta: {
                title: WebT+'-CT教学实训设备'
            }
        },
        {
            path: '/DR',
            name: 'DR',
            component: () => import('@/components/products/hardware/DR.vue'),
            meta: {
                title: WebT+'-DR教学实训设备'
            }
        },
        {
            path: '/MRI',
            name: 'MRI',
            component: () => import('@/components/products/hardware/MRI.vue'),
            meta: {
                title: WebT+'-MRI教学实训设备'
            }
        },

        //教学系统-软件
        {
            path: '/pacs',
            name: 'pacs',
            component: () => import('@/components/products/pacs.vue'),
            meta: {
                title: WebT+'-医学影像诊断思维教学系统'
            }
        },
        {
            path: '/course',
            name: 'course',
            component: () => import('@/components/products/course.vue'),
            meta: {
                title: WebT+'-医学影像处理教学系统'
            }
        },
        {
            path: '/dissect',
            name: 'dissect',
            component: () => import('@/components/products/dissect.vue'),
            meta: {
                title: WebT+'-医学影像解剖图谱'
            }
        },

        //教学系统-硬件
        {
            path: '/handle',
            name: 'handle',
            component: () => import('@/components/products/hardware/handle.vue'),
            meta: {
                title: WebT+'-三维影像后处理系统'
            }
        },
        {
            path: '/supersound',
            name: 'supersound',
            component: () => import('@/components/products/hardware/supersound.vue'),
            meta: {
                title: WebT+'-超声教学实训设备'
            }
        },
        {
            path: '/desktop',
            name: 'desktop',
            component: () => import('@/components/products/hardware/desktop.vue'),
            meta: {
                title: WebT+'-超声教学实训设备'
            }
        },
        {
            path: '/dieBody',
            name: 'dieBody',
            component: () => import('@/components/products/hardware/dieBody.vue'),
            meta: {
                title: WebT+'-医学人体模型-X线、CT、MRI'
            }
        },
        {
            path: '/dieBodyUS',
            name: 'dieBodyUS',
            component: () => import('@/components/products/hardware/dieBodyUS.vue'),
            meta: {
                title: WebT+'-医学人体模型-X线、CT、超声'
            }
        },
        {
            path: '/dieBodyUS',
            name: 'dieBodyUS',
            component: () => import('@/components/products/hardware/dieBodyUS.vue'),
            meta: {
                title: WebT+'-医学人体模型-X线、CT、超声'
            }
        },
        {
            path: '/phantom',
            name: 'phantom',
            component: () => import('@/components/products/hardware/phantom.vue'),
            meta: {
                title: WebT+'-体模'
            }
        },
        {
            path: '/adult',
            name: 'adult',
            component: () => import('@/components/products/hardware/adult.vue'),
            meta: {
                title: WebT+'-成人体模'
            }
        },
        {
            path: '/children',
            name: 'children',
            component: () => import('@/components/products/hardware/children.vue'),
            meta: {
                title: WebT+'-儿童体模'
            }
        },
        {
            path: '/animals',
            name: 'animals',
            component: () => import('@/components/products/hardware/animals.vue'),
            meta: {
                title: WebT+'-兽医体模'
            }
        },
        {
            path: '/geometry',
            name: 'geometry',
            component: () => import('@/components/products/hardware/geometry.vue'),
            meta: {
                title: WebT+'-几何'
            }
        },


        //设备结构的总页面
        {
            path: '/equipment',
            name: 'equipment',
            component: () => import('@/components/breadcrumbs/equipment.vue'),
            meta: {
                title: WebT+'-设备结构虚拟仿真系统'
            }
        },

        //性能检测的总页面
        {
            path: '/performance',
            name: 'performance',
            component: () => import('@/components/breadcrumbs/performance.vue'),
            meta: {
                title: WebT+'-设备结构虚拟仿真系统'
            }
        },

        //检查技术的总页面
        {
            path: '/check',
            name: 'check',
            component: () => import('@/components/breadcrumbs/check.vue'),
            meta: {
                title: WebT+'-检查技术虚拟仿真系统'
            }
        },

        //人体默认的总页面
        {
            path: '/model',
            name: 'model',
            component: () => import('@/components/breadcrumbs/model.vue'),
            meta: {
                title: WebT+'-医学人体模型'
            }
        },

        //教学实训设备的总页面
        {
            path: '/teaching',
            name: 'teaching',
            component: () => import('@/components/breadcrumbs/teaching.vue'),
            meta: {
                title: WebT+'-教学实训设备'
            }
        },
    ]
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
    
    // 只有整页刷新/首次进入页面才执行，点击菜单跳转不执行
    if (!from.name) {
        RefreshLimit.init()
    }
    next()
})

router.afterEach((to) => {
    document.title = to.meta.title
    document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = 0
})

export default router;